import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3a3d0948&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=3a3d0948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d0948",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutListNavigationDrawer: require('/home/leodev/Sistemas/loja/components/Layout/ListNavigationDrawer.vue').default,CartNavigationDrawer: require('/home/leodev/Sistemas/loja/components/CartNavigationDrawer.vue').default,CartEmpty: require('/home/leodev/Sistemas/loja/components/CartEmpty.vue').default,DarkMode: require('/home/leodev/Sistemas/loja/components/DarkMode.vue').default,ContaLogin: require('/home/leodev/Sistemas/loja/components/ContaLogin.vue').default,LayoutListAppBar: require('/home/leodev/Sistemas/loja/components/Layout/ListAppBar.vue').default})
